import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { deleteSpaces } from "app/utils";
import { useCelularesContext } from "../celulares-context";
import { CelularProvider, useCelularContext } from "./celular-context";
import { celularRegex } from "app/utils/regexps";
import { MdArrowBack } from "react-icons/md";

export function CelularForm() {
  return (
    <CelularProvider>
      <Form />
    </CelularProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const { addCelular, isAdding, updateCelular, isUpdating, cancel } =
    useCelularesContext();

  const { celular, setCelular, isEditing } = useCelularContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateCelular({
          celularId: params.celular_id,
          celular,
        });
      } else {
        return await addCelular({ celular });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${!!isEditing ? "Editar" : "Agregar"} número de celular`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!celular.celular_verificado ? "Verificado" : "Pendiente"
                  }
                  color={!!celular.celular_verificado ? "success" : "warning"}
                  variant="outlined"
                  size="small"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Número de celular"
              value={celular.celular_numero}
              onChange={(e) =>
                setCelular((celular) => ({
                  ...celular,
                  celular_numero: deleteSpaces(e.target.value),
                }))
              }
              inputProps={{
                pattern: celularRegex.pattern,
                title: celularRegex.title,
              }}
              size="small"
              fullWidth
              required
              disabled={!!celular.celular_verificado}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={celular.celular_principal}
                    onChange={(e) =>
                      setCelular((celular) => ({
                        ...celular,
                        celular_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es un número de celular principal?"
                disabled={!!celular.celular_verificado}
              />
            </FormGroup>
          </Grid>

          {!celular.celular_verificado && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  size="small"
                  variant="outlined"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
